import { forwardRef } from "react";

import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { InternalDepartmentResume } from "@/services/sintegradaserver/occupation/getInternalDepartmentResume";
import { TypeofOccupationFilterInitialValues } from "@/utils/initialValues/occupationFilter";
import { InternalDepartmentTypeEnum } from "@/utils/enums/sintegrada/occupation/InternalDepartmentTypeEnum";
import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	occupationFilterValues: TypeofOccupationFilterInitialValues;
	internalDepartmentResume: InternalDepartmentResume;
	isLoading?: boolean;
};

export const TotalTable = forwardRef<HTMLTableElement, Props>(
	({ occupationFilterValues, internalDepartmentResume, isLoading }, ref) => {
		const internalDepartmentName = occupationFilterValues.department.value
			.name as InternalDepartmentTypeEnum;

		const gender = occupationFilterValues.gender.value || "Todos";

		const minAge = occupationFilterValues.minAge;
		const maxAge = occupationFilterValues.maxAge;

		const ageRange = minAge && maxAge ? `${minAge} - ${maxAge}` : "Todas";

		const riskClassificationName =
			occupationFilterValues.riskClassification?.value?.name || "Todas";

		const startDate = dayjs(occupationFilterValues.startDate).format("DD/MM/YYYY HH:mm");
		const endDate = dayjs(occupationFilterValues.endDate).format("DD/MM/YYYY HH:mm");

		return (
			<Table ref={ref} id="total-table">
				<thead>
					<tr className="fw-bold">
						<th>Período</th>
						<th>Setor</th>
						<th>Ala</th>
						<th>Sexo</th>
						<th>Faixa Etária</th>
						<th>Classificação</th>
						<th>Total</th>
					</tr>
				</thead>

				<tbody>
					{isLoading ? (
						<TableSkeletons numberOfCells={7} numberOfRows={1} />
					) : Boolean(internalDepartmentResume?.department?.length) ? (
						internalDepartmentResume?.department?.map((hospitalWard, index) => (
							<tr key={`hospital-ward-${index}`}>
								<td>
									{startDate} -
									<br />
									{endDate}
								</td>
								<td>{internalDepartmentName}</td>
								<td>{hospitalWard.key}</td>
								<td>{gender}</td>
								<td>{ageRange}</td>
								<td>{riskClassificationName}</td>
								<td>{hospitalWard.total}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan={12} className="text-center text-black-50 fw-bold">
								Nenhum resultado encontrado
							</td>
						</tr>
					)}
				</tbody>
			</Table>
		);
	}
);
